module.exports = "https://de18y2hs3hlxs.cloudfront.net/04bbf00c-82ab-4e06-8439-4302b170a242/images/LogoHorizontal_White.svg?9c112b852f8360595639d7074f825d62";